<script lang="ts">
  import { INK_TOKENS, HIGHLIGHT_TOKENS, resolveInk } from '../theme/tokens';
  import { app } from './appState.svelte';
  import type { InkEngine } from '../ink/engine';

  let { engine, onclose }: { engine: InkEngine; onclose: () => void } = $props();

  // Snapshot-at-open: this component is created fresh each time the popover
  // opens (Toolbar mounts it via {#if showPen}), so the tool driving what's
  // shown here can't change out from under it while it's open.
  const tool = engine.getTool();
  const isHighlighter = tool === 'highlighter';
  const isEraser = tool === 'eraser-stroke' || tool === 'eraser-area';
  const tokens = isHighlighter ? HIGHLIGHT_TOKENS : INK_TOKENS;
  const WIDTHS = [1, 2, 3, 5, 8, 12];
  const ERASER_SIZES = [
    { label: 'Small', r: 6 },
    { label: 'Medium', r: 12 },
    { label: 'Large', r: 24 },
  ];
  let color = $state(engine.getColor());
  let width = $state(engine.getBaseWidth());
  let eraserRadius = $state(engine.getEraserRadius());

  function pickColor(t: string) { color = t; engine.setColor(t); }
  function pickWidth(w: number) { width = w; engine.setBaseWidth(w); }
  function pickEraserRadius(r: number) { eraserRadius = r; engine.setEraserRadius(r); }
</script>

<div class="scrim" onclick={onclose} role="presentation"></div>
<div class="popover">
  {#if isEraser}
    <div class="widths">
      {#each ERASER_SIZES as s}
        <button class:active={eraserRadius === s.r} onclick={() => pickEraserRadius(s.r)} aria-label={s.label}>
          <span class="eraser-preview" style="width:{s.r}px; height:{s.r}px"></span>
        </button>
      {/each}
    </div>
  {:else}
    <div class="colors">
      {#each tokens as t}
        <button class="dot" class:active={color === t} style="background:{resolveInk(t, app.theme)}" onclick={() => pickColor(t)} aria-label={t}></button>
      {/each}
    </div>
    <div class="widths">
      {#each WIDTHS as w}
        <button class:active={width === w} onclick={() => pickWidth(w)} aria-label="Width {w}">
          <span class="preview" style="height:{w}px; background: {resolveInk(color, app.theme)}"></span>
        </button>
      {/each}
    </div>
  {/if}
</div>

<style>
  .scrim { position: fixed; inset: 0; z-index: 20; }
  .popover { position: absolute; top: 64px; left: 50%; transform: translateX(-50%); z-index: 21; background: var(--surface); border-radius: var(--radius-panel); box-shadow: var(--shadow-soft); padding: 14px; display: flex; flex-direction: column; gap: 12px; }
  .colors { display: grid; grid-template-columns: repeat(4, 1fr); gap: 8px; }
  .dot { width: 36px; height: 36px; border-radius: 50%; border: 2px solid transparent; cursor: pointer; }
  .dot.active { border-color: var(--accent); }
  .widths { display: flex; gap: 8px; }
  .widths button { flex: 1; height: 40px; display: grid; place-items: center; border: 1px solid var(--hairline); border-radius: 8px; background: var(--paper); cursor: pointer; }
  .widths button.active { border-color: var(--accent); }
  .preview { display: block; width: 28px; border-radius: 4px; }
  .eraser-preview { display: block; border-radius: 50%; background: var(--ink-primary); }
</style>
